import { useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FormDispatchContext } from '../../contexts/FormContext';
// ----------------------------------------------------------------------

export default function MediumWithinCMS(props) {

    const [ mediumValue, setMediumValue ] = useState('card');
    const settingsUpdate = useContext(FormDispatchContext);
    
    const handleChange = (e) => { 
        setMediumValue( e.target.value );
        settingsUpdate({ type: 'set_medium', medium: e.target.value });
    }

    return ( 
        <Box className="workingfeedback-question-block" sx={{ backgroundColor: 'rgb(255, 247, 205)', padding: '15px' }} data-question-type="WITHIN_CMS_MEDIUM_SELECTOR" data-tracked={false} data-multiple-choice="No">
            <Grid container spacing={2}>
                <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                    <Typography variant="body2" className="workingfeedback-question-title" component="h6">How was the review submitted to us?</Typography>
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    <Select size="small" sx={{ width: '100%' }} value={mediumValue} onChange={(e) => handleChange(e)}>
                        <MenuItem value="online">Please select</MenuItem>
                        <MenuItem value="card">Returned a postage paid feedback form</MenuItem>
                        <MenuItem value="testimonial">Testimonial / thank you letter / card /etc</MenuItem>
                        <MenuItem value="email">Sent an email to us which contained a review</MenuItem>
                        <MenuItem value="sms">Sent, or replied to, an SMS text message</MenuItem>
                        <MenuItem value="other">Something not in the list above</MenuItem>                
                    </Select>
                </Grid>
            </Grid>
        </Box>
    )
}
